import { render, staticRenderFns } from "./UploadReview.vue?vue&type=template&id=5cce68c2&scoped=true&"
import script from "./UploadReview.vue?vue&type=script&lang=js&"
export * from "./UploadReview.vue?vue&type=script&lang=js&"
import style0 from "./UploadReview.vue?vue&type=style&index=0&id=5cce68c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce68c2",
  null
  
)

export default component.exports